/**
 * Invoice entity type DTO enum - matches backend API contract
 * Represents the type of entity associated with an invoice line item
 */
export enum InvoiceEntityTypeDTO {
  USER = 'USER',
  UNKNOWN = 'UNKNOWN',
  OVERHEAD = 'OVERHEAD',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type InvoiceEntityTypeRequest = InvoiceEntityTypeDTO;
export type InvoiceEntityTypeResponse = InvoiceEntityTypeDTO;
